export const getAssetsView = (state) => state.uiState.assetsView;
export const getAssetsSortBy = (state) => state.uiState.assetsSort.sortBy;
export const getAssetsSortDirection = (state) => state.uiState.assetsSort.reversed;

export const getConfirmationState = (state) => state.uiState.confirmation;

// playlist tags update
export const getPlaylistUdpateState = (state) => state.uiState.playlistUpdateTags;

export const getbulkUpdatePlaylists = (state) => state.uiState.bulkPlaylistsUpdate;

export const getUploadTrayOpen = (state) => state.uiState.uploadTrayOpen;

export const getUploadState = (state) => state.uiState.uploadTypeSwitch
export const getUploadDispatchState = (state) => state.uiState.uploadDispatchState
export const getUploadResumeState = (state) => state.uiState.uploadStartState
export const getUploadVisibility = (state) => state.uiState.uploadDispatchState;

export const getPageTitle = (state) => state.uiState.pageTitle;
export const getHelpVisibility = (state) => state.uiState.helpVisible;
export const getFilterBarVisible = (state) => state.uiState.filterBarVisible;

export const getCurrentDeviceId = (state) => state.deviceState.currentDeviceId

export const getDetailPlaylist = (state) => state.uiState.playlistDetail.data;
export const getLoadingPlaylistDetail = (state) => state.uiState.playlistDetail.loading;



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/selectors/ui.js